import React, { useEffect, useState } from "react";
import { Typography, Button } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import { Person, PhoneAndroid } from "@mui/icons-material";
import GoogleIcon from "../../Assets/Icon/GoogleIcon";
import '../../CSS/LoginComponent/RegisterElement.css'
import { getUserProfile, loginWithGoogle, registerUser } from "../../api/authApi";
import { preloadGoogleAuth, requestGoogleAuthCode } from "../../utils/googleAuth";
import { clearAuthTokens, setAuthTokens } from "../../utils/authStorage";
import { useAuth } from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";

const RegisterElement = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNum: "",
    email: "",
    password: ""
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    preloadGoogleAuth();
  }, []);

  const handleChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value
    });
  };

  const handleRegister = async () => {
    try {
      setLoading(true);

      const result = await registerUser(formData);

      alert(result);

    } catch (error) {
      console.error(error);
      alert("Registration failed");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleRegister = async () => {
    try {
      setLoading(true);

      const authCode = await requestGoogleAuthCode();
      const loginResult = await loginWithGoogle(authCode);
      const token = loginResult?.token || loginResult?.accessToken || loginResult;
      const refreshToken = loginResult?.refreshToken;

      setAuthTokens({ accessToken: token, refreshToken });
      const profileData = await getUserProfile();
      login(token, profileData, refreshToken);

      alert("Login Successful!");
      navigate('/');
    } catch (error) {
      console.error(error);
      clearAuthTokens();
      alert(error?.message === "Missing REACT_APP_GOOGLE_CLIENT_ID"
        ? "Google Client ID is not configured."
        : "Google Sign In Failed");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="register-container">

      <div className="contact-name-row">
        <img src="/sejiwa-logo-2.png" alt="Sejiwa Logo" className="contact-logo" />
        <h1 className="contact-name">Sejiwa</h1>
      </div>

      <Typography variant="body1" color="text.secondary" gutterBottom marginBottom={4}>
        Create an account
      </Typography>

      {/* Temporarily hidden normal sign up
      <div className="input-wrapper">
        <div className="name-container">
          <Person className="input-icon" />
          <input
            type="text"
            placeholder="Name"
            className="input-field"
            onChange={(e) => handleChange("fullName", e.target.value)}
          />
        </div>
      </div>

      <div className="input-wrapper">
        <div className="email-container">
          <EmailIcon className="input-icon" />
          <input
            type="text"
            placeholder="Email"
            className="input-field"
            onChange={(e) => handleChange("email", e.target.value)}
          />
        </div>
      </div>

      <div className="input-wrapper">
        <div className="phoneNum-container">
          <PhoneAndroid className="input-icon" />
          <input
            type="text"
            placeholder="Phone Number"
            className="input-field"
            onChange={(e) => handleChange("phoneNum", e.target.value)}
          />
        </div>
      </div>

      <div className="input-wrapper">
        <div className="password-register-container">
          <LockIcon className="input-icon" />
          <input
            type="password"
            placeholder="Password"
            className="input-field"
            onChange={(e) => handleChange("password", e.target.value)}
          />
        </div>
      </div>


      <Button
        variant="contained"
        disableElevation
        onClick={handleRegister}
        disabled={loading}
        sx={{
          width: "100%",
          textTransform: "none",
          backgroundColor: "#55C2C3",
          borderRadius: "30px",
          paddingY: "10px",
          fontSize: "16px",
          marginBottom: "30px",
          "&:hover": { backgroundColor: "#48A6A7", transition: "0.3s" }
        }}
      >
        {loading ? "Signing Up..." : "Sign Up"}
      </Button>


      <div className="divider-row">
        <hr className="divider-line" />
        <Typography color="text.secondary" marginInline={5}>or</Typography>
        <hr className="divider-line" />
      </div>
      */}

      <Button
        variant="contained"
        disableElevation
        onClick={handleGoogleRegister}
        disabled={loading}
        sx={{
          width: "100%",
          textTransform: "none",
          color: "#333",
          backgroundColor: "#F2F2F2",
          borderRadius: "30px",
          gap: "10px",
          paddingY: "10px",
          fontSize: "16px",
          marginBottom: "20px",
          "&:hover": { backgroundColor: "#E8E8E8", transition: "0.3s" }
        }}
      >
        <GoogleIcon className="google-icon" />
        {loading ? "Opening Google..." : "Sign Up with Google"}
      </Button>



      {/* Temporarily hidden sign in link
      <Typography variant="body1" color="text.secondary" fontSize={16}>
        Already have an account?{" "}
        <Typography
          component="a"
          href="login"
          className="signup-link"
        >
          Sign in.
        </Typography>
      </Typography>
      */}

    </div>
  );
};

export default RegisterElement;
